module.exports = __webpack_public_path__ + "img/x2.e1836c50.jpg";